const information = {
  'SERVICE_ID':"service_fpnm2qg",
  "userID": "user_JNSVcudpjUSYNcI2QT2zn", 
  "TemplastForm": "template_z8i2wsk"
};
// 
//template_vugk1ln
export default information;